<template>
	<div class="checkOrderRight">
		<div>
			<el-tabs v-model="activeName" type="card">
				<el-tab-pane label="位置信息" name="one">
					<span>提示：如果没有电梯标示，请及时进行电梯定位操作。</span>
					<MapBox :detail="detail" />
				</el-tab-pane>
				<el-tab-pane label="图片信息" name="two">
					<div>
						<el-tabs v-model="photoName" type="card">
							<el-tab-pane label="现场图片" name="liveImageDataList">
								<ul class="photoBox" v-if="!hasRole['WBGDTPXG']">
									<li v-for="item in detail.liveImageDataList" :key="item.id">
										<el-image
											style="width: 100px; height: 100px"
											:src="item.imageUrl"
											:z-index="9999"
											:preview-src-list="
												detail.liveImageDataList.map((it) => it.imageUrl)
											"
										>
										</el-image>
									</li>
								</ul>
								<el-upload
									action="/KYWB/foreign/storage/uploadFile"
									:headers="headersObj"
									list-type="picture-card"
									:file-list="liveImageFileList"
									:on-preview="handlePictureCardPreview"
									:on-remove="handleRemove"
                  :before-remove="beforeRemove"
									:on-success="handleSuccess"
                  v-if="hasRole['WBGDTPXG']"
								>
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-tab-pane>
							<el-tab-pane label="工单图片" name="orderImageDataList">
								<ul class="photoBox"  v-if="!hasRole['WBGDTPXG']">
									<li v-for="item in detail.orderImageDataList" :key="item.id">
										<el-image
											style="width: 100px; height: 100px"
											:src="item.imageUrl"
											:z-index="9999"
											:preview-src-list="
												detail.orderImageDataList.map((it) => it.imageUrl)
											"
										>
										</el-image>
									</li>
								</ul>
								<el-upload
									action="/KYWB/foreign/storage/uploadFile"
									:headers="headersObj"
									list-type="picture-card"
									:file-list="orderImageFileList"
									:on-preview="handlePictureCardPreview"
									:on-remove="handleRemove2"
                  :before-remove="beforeRemove2"
									:on-success="handleSuccess2"
                   v-if="hasRole['WBGDTPXG']"
								>
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-tab-pane>
							<el-tab-pane label="签名图片" name="signatureImageDataList">
								<ul class="photoBox">
									<li
										v-for="item in detail.signatureImageDataList"
										:key="item.id"
									>
										<el-image
											style="width: 100px; height: 100px"
											:src="item.imageUrl"
											:z-index="9999"
											:preview-src-list="
												detail.signatureImageDataList.map((it) => it.imageUrl)
											"
										>
										</el-image>
									</li>
								</ul>
							</el-tab-pane>
              <el-tab-pane label="客户签名图片" name="customerSignatureImageDataList">
              	<ul class="photoBox">
              		<li
              			v-for="item in detail.customerSignatureImageDataList"
              			:key="item.id"
              		>
              			<el-image
              				style="width: 100px; height: 100px"
              				:src="item.imageUrl"
              				:z-index="9999"
              				:preview-src-list="
              					detail.customerSignatureImageDataList.map((it) => it.imageUrl)
              				"
              			>
              			</el-image>
              		</li>
              	</ul>
              </el-tab-pane>
						</el-tabs>
					</div>
				</el-tab-pane>
				<el-tab-pane label="保养项目" name="three">
					<el-table
						:data="detail.manageItemDTOS"
						style="width: 100%"
						max-height="600px"
					><el-table-column type="index" label="序号" width="80"></el-table-column>
						<el-table-column prop="itemName" label="名称" width="100">
						</el-table-column>
						<el-table-column prop="locationName" label="部位" width="70">
						</el-table-column>
						<el-table-column
							prop="requirements"
							label="要求"
							show-overflow-tooltip
						>
						</el-table-column>
						<el-table-column
							prop="result"
							width="100"
							label="记录"
							show-overflow-tooltip
						>
							<template slot-scope="scope">
								{{ scope.row.result | filterR }}
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane label="电梯信息" name="four">
					<div class="liftDetailBox">
						<div class="liftDetail">
							<p>电梯信息</p>
							<ul>
								<li>
									<span>电梯类型</span
									><span>{{ detail.lift.liftTypeName }}</span>
								</li>
								<li>
									<span>使用单位</span
									><span>{{ detail.lift.propertyUnitName }}</span>
								</li>
								<li>
									<span>项目名称</span
									><span>{{ detail.lift.projectName }}</span>
								</li>
								<li>
									<span>电梯品牌</span><span>{{ detail.lift.liftBrand }}</span>
								</li>
								<li>
									<span>制造单位</span
									><span>{{ detail.lift.manufactureCompany }}</span>
								</li>
								<li>
									<span>制造日期</span
									><span>{{ detail.lift.manufactureDate }}</span>
								</li>
								<li>
									<span>安装单位</span
									><span>{{ detail.lift.installCompany }}</span>
								</li>
								<li>
									<span>载重</span><span>{{ detail.lift.nominalLoad }}</span>
								</li>
								<li>
									<span>层站数</span
									><span>{{ detail.lift.stationNumber }}</span>
								</li>
								<li>
									<span>控制方式</span
									><span>{{ detail.lift.controlMode }}</span>
								</li>
								<li>
									<span>额定速度</span
									><span>{{ detail.lift.nominalSpeed }}</span>
								</li>
								<li>
									<span>出厂编号</span
									><span>{{ detail.lift.factoryNumber }}</span>
								</li>
								<li>
									<span>运行方式</span
									><span>{{ detail.lift.modeOperation }}</span>
								</li>
								<li>
									<span>设备型号</span><span>{{ detail.lift.unitType }}</span>
								</li>
								<li>
									<span>使用证编号</span
									><span>{{ detail.lift.useCertificateNumber }}</span>
								</li>
								<li>
									<span>注册代码</span
									><span>{{ detail.lift.registerCode }}</span>
								</li>
								<li>
									<span>注册单位</span
									><span>{{ detail.lift.registeredUnit }}</span>
								</li>
							</ul>
						</div>
						<div class="contractDetail">
							<p>合同信息</p>
							<ul>
								<li>
									<span>付款日期</span
									><span>{{ detail.lift.paymentDate }}</span>
								</li>
								<li>
									<span>维保合同到期时间</span
									>{{ detail.lift.maintenanceEndDate }}<span></span>
								</li>
								<li>
									<span>合同联系人</span
									><span>{{ detail.lift.contractContact }}</span>
								</li>
								<li>
									<span>联系电话</span
									><span>{{ detail.lift.contractContactPhone }}</span>
								</li>
								<li>
									<span>配件约定</span
									><span>{{ detail.lift.accessoriesAmount }}</span>
								</li>
								<li>
									<span>税收票证</span><span>{{ detail.lift.taxTicket }}</span>
								</li>
								<li>
									<span>维保间隔</span
									><span>{{ detail.lift.maintenanceInterval }}</span>
								</li>
							</ul>
						</div>
						<div class="yearDetail">
							<p>年检信息</p>
							<ul>
								<li>
									<span>检验人员</span
									><span>{{ detail.lift.inspectionPersonnel }}</span>
								</li>
								<li>
									<span>检验单位</span
									><span>{{ detail.lift.inspectionUnit }}</span>
								</li>
								<li>
									<span>年检报告编号</span
									><span>{{ detail.lift.inspectionReportCode }}</span>
								</li>
								<li>
									<span>年检日期</span
									><span>{{ detail.lift.annualInspectionDate }}</span>
								</li>
								<li>
									<span>下次年检日期</span
									><span>{{ detail.lift.nextAnnualInspectionDate }}</span>
								</li>
							</ul>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="人员信息" name="five">
					<el-table
						:data="detail.maintainOrderTeamworkList"
						style="width: 100%"
					>
						<el-table-column label="姓名">
							<template slot-scope="scope">
								<span>{{ scope.row.teamworkUserName }}</span>
							</template>
						</el-table-column>
						<el-table-column label="姓名">
							<template slot-scope="scope">
								<el-image
									style="height: 40px"
									:src="scope.row.imageUrl"
									:preview-src-list="[scope.row.imageUrl]"
								>
								</el-image>
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
			</el-tabs>
		</div>
		<el-dialog :visible.sync="dialogVisible" :modal="false">
			<el-image width="100%" :src="dialogImageUrl" :preview-src-list="dialogImageUrlList" alt="" ></el-image>
		</el-dialog>
	</div>
</template>
<script>
import MapBox from "./MapBox";
import cookies from "../../../libs/util.cookies";
import { updateImage } from "@/api/MaintenanceWorkOrder";
export default {
	components: {
		MapBox,
	},
	props: {
		detail: {
			type: Object,
			default: () => {
				return {
					lift: {},
					liveImageDataList: [],
					logList: [],
					maintainOrderTeamworkList: [],
				};
			},
		},
	},
	watch: {
		detail: {
			handler(newVal) {
				console.log(newVal);
				let liveImages = newVal.liveImageDataList;
				let orderImages = newVal.orderImageDataList;
				if (liveImages) {
					this.liveImageFileList = liveImages.map((item) => ({
						name: item.imageUrl,
						url: item.imageUrl,
					}));
				}
				if (orderImages) {
					this.orderImageFileList = orderImages.map((item) => ({
						name: item.imageUrl,
						url: item.imageUrl,
					}));
				}
			},
			deep: true,
		},
	},

	data() {
		return {
			liveImageFileList: [],
			orderImageFileList: [],
			activeName: "one",
			photoName: "liveImageDataList",
			dialogImageUrl: "",
      dialogImageUrlList: [],
			dialogVisible: false,
			headersObj: {
				Authorization: "Bearer ",
				appCode: "YHGHT",
			},
		};
	},
  computed: {
    hasRole: function() {
      return this.$store.getters['common/promise/getRole'](this.$route.path);
    }
  },
	created() {
		this.headersObj.Authorization = this.headersObj.Authorization +=
			cookies.get("token");
	},
	methods: {
		handleRemove(file, fileList) {
			console.log(fileList);
			this.liveImageFileList = fileList;
			this.saveImg(1);
		},
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除当前图片？`);
    },
		handleSuccess(res) {
			if (res && res.data) {
				this.liveImageFileList.push({
					name: res.data.url,
					url: res.data.url,
				});
				this.saveImg(1);
			}
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
      this.dialogImageUrlList = [file.url];
			this.dialogVisible = true;
      console.log(this.dialogImageUrlList)
		},
		handleRemove2(file, fileList) {
			this.orderImageFileList = fileList;
			this.saveImg(2);
		},
    beforeRemove2(file, fileList) {
      return this.$confirm(`确定移除当前图片？`);
    },
		handleSuccess2(res) {
			if (res && res.data) {
				this.orderImageFileList.push({
					name: res.data.url,
					url: res.data.url,
				});
				this.saveImg(2);
			}
		},
		async saveImg(type) {
			const params = {
				imageType: type,
				orderId: this.detail.orderId,
			};
			let arr = [];
			if (type == 1) {
				arr = this.liveImageFileList;
			} else {
				arr = this.orderImageFileList;
			}
			params.imageList = arr.map((item) => item.url);
			await updateImage(params);
		},
	},
	filters: {
		filterR(val) {
			if (val == 1) {
				return "正常";
			} else if (val == 2) {
				return "出错";
			} else if (val == 3) {
				return "无此项";
			} else if (val == 4) {
				return "问题已整改";
			} else if (val == 5) {
				return "已更换零件";
			} else {
				return "";
			}
		},
	},
};
</script>
<style lang="scss">
.checkOrderRight {
	padding-left: 20px;
	.photoBox {
		display: flex;
		li {
			margin-right: 20px;
		}
	}
	.video-container {
		padding: 10px 0;
	}
	.no-video {
		padding: 20px;
		text-align: center;
		color: #999;
	}
	.video-info {
		margin-top: 15px;
		padding: 10px;
		border-top: 1px solid #eee;
		
		.info-item {
			display: flex;
			margin-bottom: 8px;
			
			.label {
				width: 120px;
				color: #606266;
				font-weight: 500;
			}
			
			.value {
				color: #333;
			}
			
			.tip-icon {
				margin-left: 5px;
				color: #909399;
				cursor: pointer;
				font-size: 14px;
			}
		}
	}
	.liftDetailBox {
		max-height: 600px;
		overflow-y: auto;
		border: 1px solid #ccc;
		border-bottom: none;
		p {
			padding: 4px 0;
			border-bottom: 1px solid #ccc;
			text-align: center;
			// border-top: 1px solid #ccc;
		}
		.liftDetail p {
			border-top: none;
		}
		li {
			border-bottom: 1px solid #ccc;
			display: flex;
			span {
				flex: 0.4;
				padding: 4px 0;
				padding-left: 20px;
			}
			span:last-child {
				flex: 0.6;
				border-left: 1px solid #ccc;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/MaintenanceWorkOrder/components/CheckOrderRight.vue